/**
 * Test users for local development.
 * Each user has a unique ID, name, email, and set of interests.
 */

export const TEST_USERS = [
  {
    id: 'test-user-123',
    name: 'Alice Johnson',
    email: 'alice@test.local',
    interests: 'soccer, programming, coffee',
  },
  {
    id: 'test-user-456',
    name: 'Bob Smith',
    email: 'bob@test.local',
    interests: 'music, photography, travel',
  },
  {
    id: 'test-user-789',
    name: 'Carol Davis',
    email: 'carol@test.local',
    interests: 'cooking, gardening, yoga',
  },
  {
    id: 'test-user-101',
    name: 'David Lee',
    email: 'david@test.local',
    interests: 'gaming, technology, anime',
  },
];

/**
 * Get currently selected test user from localStorage
 */
export const getCurrentTestUser = () => {
  const savedUserId = localStorage.getItem('dev_user_id');
  const user = TEST_USERS.find(u => u.id === savedUserId);
  return user || TEST_USERS[0]; // Default to first user
};

/**
 * Set the current test user in localStorage
 */
export const setCurrentTestUser = (userId) => {
  localStorage.setItem('dev_user_id', userId);
};
